module.exports = __webpack_public_path__ + "static/img/xi_5.846f7e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_5.png
// module id = Sd3I
// module chunks = 1